import { roleInstance } from 'Interfaces/roleBasedAccessInterfaces';

interface salesPlanAllowedRolesInterface {
  createNewSalesPlan: roleInstance[];
  bulkUpdateSalesPlan: roleInstance[];
}

interface unconstrainedForecastAllowedRolesInterface {
  createNewPlanButton: roleInstance[];
  bulkUpdateUnconstrainedForecast: roleInstance[];
}
interface constrainedForecastAllowedRolesInterface {
  createNewPlanButton: roleInstance[];
  bulkUpdateConstrainedForecast: roleInstance[];
}
interface supplierForecastAllowedRolesInterface {
  triggerSupplierForecast: roleInstance[];
  exportSupplierForecastButton: roleInstance[];
}
interface provisionalForecastAllowedRolesInterface {
  createProvisionalForecast: roleInstance[];
  bulkUpdateProvisionalForecast: roleInstance[];
}

export const salesPlanAllowedRoles: salesPlanAllowedRolesInterface = {
  createNewSalesPlan: [{ department: 'salesOps', role: 'basicUser' }],
  bulkUpdateSalesPlan: [{ department: 'salesOps', role: 'basicUser' }],
};

export const unconstrainedForecastAllowedRoles: unconstrainedForecastAllowedRolesInterface = {
  createNewPlanButton: [{ department: 'salesOps', role: 'basicUser' }],
  bulkUpdateUnconstrainedForecast: [{ department: 'salesOps', role: 'basicUser' }],
};

export const constrainedForecastAllowedRoles: constrainedForecastAllowedRolesInterface = {
  createNewPlanButton: [{ department: 'supplier', role: 'basicUser' }],
  bulkUpdateConstrainedForecast: [{ department: 'supplier', role: 'basicUser' }],
};

export const supplierForecastAllowedRoles: supplierForecastAllowedRolesInterface = {
  triggerSupplierForecast: [{ department: 'supplier', role: 'basicUser' }],
  exportSupplierForecastButton: [{ department: 'supplier', role: 'basicUser' }],
};

export const provisionalForecastAllowedRoles: provisionalForecastAllowedRolesInterface = {
  createProvisionalForecast: [{ department: 'salesOps', role: 'basicUser' }],
  bulkUpdateProvisionalForecast: [{ department: 'salesOps', role: 'basicUser' }],
};
